import React, { useState } from "react";
import { getCertificateStatus, getGreenLogo } from "./enums";
import { getLocalizedCompanyUserTitle } from "../companyUserTitle";
import "./styles.css";

export default function Hotel(data: any) {
  const [lang, setLang] = useState(true);
  const greenHotelData = data.data.data;

  const getFooter = () => {
    return (
      <div className='certificate-footer'>
        <span className='certificate-footer__label'>
          {lang ? "INFORMATION NOTE:" : "BİLGİ NOTU:"}
        </span>
        <span className='certificate-footer__note'>
          {lang
            ? " This verify/certificate has been issued by " +
              getLocalizedCompanyUserTitle(
                greenHotelData?.companyUserTitle,
                lang,
                { fallbackToDefault: true },
              ) +
              " under the authority of Turkish Ministry of Culture & Tourism."
            : "Bu sertifika, TC Kültür ve Turizm Bakanlığı tarafından yetkilendirilmiş " +
              getLocalizedCompanyUserTitle(
                greenHotelData?.companyUserTitle,
                lang,
                { fallbackToDefault: true },
              ) +
              " tarafından verilmiştir."}
        </span>
      </div>
    );
  };

  const getGreenHotelContent = () => {
    return (
      <div className='certificates__green-certificate'>
        <div className='certificate-info'>
          <div className='certificate-info__line'>
            <span className='certificate-info__label'>
              {lang ? "Issue Date" : "Sertifika Düzenleme Tarihi"}
            </span>
            <span className='certificate-info__colon'>:</span>
            <span className='certificate-info__value'>
              {greenHotelData?.confirmationDateString}
            </span>
          </div>
          <div className='certificate-info__line'>
            <span className='certificate-info__label'>
              {lang ? "Expiry Date" : "Sertifika Geçerlilik Tarihi"}
            </span>
            <span className='certificate-info__colon'>:</span>
            <span className='certificate-info__value'>
              {greenHotelData?.extendedClosedDateString}
            </span>
          </div>
          <div className='certificate-info__line'>
            <span className='certificate-info__label'>
              {lang
                ? "Certificate/Status"
                : "Sürdürülebilir Turizm Sertifika / Belge Durumu"}
            </span>
            <span className='certificate-info__colon'>:</span>
            <span className='certificate-info__value'>
              {getCertificateStatus(lang, greenHotelData?.status)}
            </span>
          </div>
          <div className='certificate-info__line'>
            <span className='certificate-info__label'>
              {lang ? "Facility Name" : "Tesis Adı"}
            </span>
            <span className='certificate-info__colon'>:</span>
            <span className='certificate-info__value'>
              {greenHotelData?.brandName}
            </span>
          </div>
          <div className='certificate-info__line'>
            <span className='certificate-info__label'>
              {lang
                ? "Certificate / Verification Number"
                : "Sertifika/Belge Numarası"}
            </span>
            <span className='certificate-info__colon'>:</span>
            <span className='certificate-info__value'>
              {greenHotelData?.certificateNo}
            </span>
          </div>
          <div className='certificate-info__line'>
            <span className='certificate-info__label'>
              {lang ? "Category" : "Tesis Kategorisi"}
            </span>
            <span className='certificate-info__colon'>:</span>
            <span className='certificate-info__value'>
              {lang
                ? greenHotelData?.layoverSubCategoryName_En
                : greenHotelData?.layoverSubCategoryName}
            </span>
          </div>
          <div className='certificate-info__line'>
            <span className='certificate-info__label'>
              {lang ? "Location" : "İl / İlçe"}
            </span>
            <span className='certificate-info__colon'>:</span>
            <span className='certificate-info__value'>
              {greenHotelData?.cityDistrictName}
            </span>
          </div>
          <div className='certificate-info__line'>
            <span className='certificate-info__label'>
              {lang ? "Certified by" : "Uygunluk Değerlendirme Kuruluşu"}
            </span>
            <span className='certificate-info__colon'>:</span>
            <span className='certificate-info__value'>
              {getLocalizedCompanyUserTitle(
                greenHotelData?.companyUserTitle,
                lang,
              )}
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <button className='languageButton' onClick={(x) => setLang(!lang)}>
        {lang ? "TR" : "EN"}
      </button>
      <div className='container'>
        <div className='certificate green-certificate'>
          <div className='certificate-heading green-certificate__heading'>
            {lang
              ? "TÜRKİYE ENVIRONMENTAL AND CULTURAL SUSTAINABILITY PROGRAM"
              : "ÇEVRESEL VE KÜLTÜREL SÜRDÜRÜLEBİLİRLİK PROGRAMI"}
          </div>
          <div className='certificate-logo'>
            <img
              src={getGreenLogo(lang, greenHotelData?.status)}
              alt='Safe Tourism Logo'
              width='140'
            />
          </div>
          {getGreenHotelContent()}
        </div>
        {getFooter()}
      </div>
    </>
  );
}
